<template>
  <div v-if="product && product.collection && product.collection.productThumbnail && product.collection.productCount>1" class="collections">
    <h2 class="light title">Collection</h2>
    <div class="product-collection-section desktop">
      <div class="flex-grid">
        <a v-for="collectionProduct in product.collection.productThumbnail" :key="collectionProduct.hashKey" :href="$router.resolve({ name: 'product', params: { id: collectionProduct.hashKey, slug: collectionProduct.slug } }).href" class="flex-col-4-xs">
          <PreserveRatio :width="2890" :height="1500">
            <ResponsiveImage :url="`${collectionProduct.imageUrl}?fit=max&w={width}&q={q}`" :widths="[130, 245, 310, 190]" :breakpoints="[320, 425, 768, 970]" />
          </PreserveRatio>
        </a>
      </div>
      <p>
        There's more! The {{ product.collection.name }} collection consists of {{ product.collection.productCount }} different pieces.
        <a :href="$router.resolve({ name: 'collection', params: { id: product.collection.id, slug: product.collection.slug } }).href">Check out the full collection</a>.
      </p>
    </div>
  </div>
</template>

<script>
import { PreserveRatio } from '@article/pixel';
import { mapState } from 'vuex';
import ResponsiveImage from '@/components/commons/ResponsiveImage.vue';

export default {
  name: 'Collections',
  components: {
    ResponsiveImage,
    PreserveRatio
  },
  computed: {
    ...mapState('product', [
      'product', //
    ])
  }
};
</script>

<style lang="scss">
@import '~@article/pixel/dist/style/variables';

.collections {
  .title {
    margin-bottom: 12px;
  }

  p {
    margin: 0px;
  }

  @media (max-width: $tablet-breakpoint - 1) {
    box-sizing: border-box;
    padding: 20px 20px 0px 20px;
  }
}
</style>
